'use client'

import { ButtonSecondary } from 'fukku/Button/Secondary'
import { useLabels } from 'labels/hooks/useLabels/useLabels'

import styles from './DetailsButton.module.scss'

interface DetailsButtonProps {
	orderId: string
	label: string
	handleClick?: () => void
}

export function DetailsButton({
	orderId,
	label,
	handleClick,
}: DetailsButtonProps) {
	const { t } = useLabels()

	return (
		<ButtonSecondary
			data-testid={`myPurchases.purchaseCard.viewDetails.${orderId}`}
			aria-label={`${t('my_purchases.cta.view_details')} ${orderId}`}
			onClick={handleClick}
			className={styles.button}
		>
			{label}
		</ButtonSecondary>
	)
}
